require('./brokerOrdersAndMovementsActivityFilter.scss');
require('./brokerOrdersAndMovementsActivityFilter.override.scss');
const PropTypes = require('prop-types');
// @ vendors
const React = require('react');
const cloneDeep = require('lodash/lang/cloneDeep');
// @ helpers
const { FormattedText, formatText } = require('core/i18n').i18n;
// @ commons
const DateFilter = require('components/commons/dateFilter/dateFilter');
const OKModal = require('components/commons/OKModal/OKModal');
const OKSelect = require('components/commons/OKSelect/OKSelect');
const OKTooltip = require('components/commons/OKTooltip/OKTooltip');
// @ constants
const ORDER_STATES = [
    {value: ' ', label: 'broker-ordersAndMovementsStateAll'},//(nicolas.olmos) This is not a valid API value. It is replaced on the action.
    {value: 'E', label: 'broker-ordersAndMovementsStateExecuted'},
    {value: 'A', label: 'broker-ordersAndMovementsStateCancelled'},
    {value: 'P', label: 'broker-ordersAndMovementsStatePending'},
    {value: 'X', label: 'broker-ordersAndMovementsStateSettledInMarket'},
    {value: 'Y', label: 'broker-ordersAndMovementsStatePartiallyExecuted'}
];

class BrokerOrdersAndMovementsActivityFilter extends React.Component {
    constructor(props) {
        super(props);

        const { immFilter } = props;
        const immDate = immFilter.get('date');
        let orderStates = cloneDeep(ORDER_STATES)
        orderStates = orderStates.map(o => ({...o, label: formatText(o.label)}));

        this.state = {
            dateSelected: immDate.get('selected'),
            dateFrom: immDate.get('from'),
            dateTo: immDate.get('to'),
            orderValue: immFilter.getIn(['state','value']),
            orderStates
        };

        this.handleFormSubmit = this.handleFormSubmit.bind(this);
        this.handleChangeDateMin = this.handleChangeDateMin.bind(this);
        this.handleChangeDateMax = this.handleChangeDateMax.bind(this);
        this.handleChangeDateSelected = this.handleChangeDateSelected.bind(this);
        this.handleChangeState = this.handleChangeState.bind(this);
        this.handleCloseWindow = this.handleCloseWindow.bind(this);
    }

    handleChangeDateMax(dateTo) {
        this.setState({
            dateTo
        });
    }

    handleChangeDateMin(dateFrom) {
        this.setState({
            dateFrom
        });
    }

    handleChangeDateSelected(dateSelected) {
        this.setState({
            dateSelected
        });
    }

    handleChangeState(order) {
        this.setState({
            orderValue: order.value
        });
    }

    handleCloseWindow() {
        const { onCloseClick, immFilter, } = this.props;
        const { orderValue } = this.state;
        const orderValueStore = immFilter.getIn(['state', 'value']);

        if (orderValue !== orderValueStore) {
            this.setState({
                orderValue: orderValueStore
            });
        }
        onCloseClick();
    }

    handleFormSubmit() {
        const { setFilter, onCloseClick, contractId } = this.props;
        const { dateFrom, dateTo, dateSelected, orderValue } = this.state;
        const newFilter = {
            date: {
                selected: dateSelected,
                from: dateFrom,
                to: dateTo,
                isActive: true
            },
            state: {
                value: orderValue,
                isActive: true
            }
        };

        ORDER_STATES.forEach(option => {
            if (option.value === orderValue) { newFilter.state.translation = formatText(option.label) }
        })

        setFilter(newFilter, contractId);
        onCloseClick();
    }

    render() {
        const {
            immFilter,
            isModalOpen
        } = this.props;
        const { orderValue, orderStates } = this.state;

        const modalTitle = (
            <React.Fragment>
                <FormattedText value="broker-ordersAndMovementsFilterTitleOrders" />
                <OKTooltip
                    content="filters-tooltip"
                    placement="right"
                    offset={[15,2]}
                />
            </React.Fragment>
        );

        const modalContent = (
            <div className="broker-orders-and-movements-activity-filter">
                <form
                    className="broker-orders-and-movements-activity-filter__form"
                >
                    <fieldset>
                        <div className="col-xs-12">
                            <DateFilter
                                immFilter={immFilter.get('date')}
                                onChangeMin={this.handleChangeDateMin}
                                onChangeMax={this.handleChangeDateMax}
                                onChangeSelected={this.handleChangeDateSelected}
                            />
                        </div>
                    </fieldset>
                    <fieldset className="broker-orders-and-movements-activity-filter__select">
                        <OKSelect
                            id="sel_brokerOrdersAndMovementsActivityFilter_state"
                            label="broker-ordersAndMovementsFiltersState"
                            name="state"
                            options={orderStates}
                            value={orderValue}
                            clearable={false}
                            searchable={false}
                            onChange={this.handleChangeState}
                            openUp={true}
                        />
                    </fieldset>
                </form>
            </div>
        );

        return (
            <OKModal
                content={modalContent}
                footerType="navigation"
                isOpen={isModalOpen}
                onCloseCallback={this.handleCloseWindow}
                onPrimaryButtonClick={this.handleFormSubmit}
                onSecondaryButtonClick={this.handleCloseWindow}
                primaryButtonText="filterDate-apply"
                secondaryButtonText="filterDate-cancel"
                title={modalTitle}
            />
        );
    }
}

BrokerOrdersAndMovementsActivityFilter.propTypes = {
    contractId: PropTypes.string.isRequired,
    immFilter: PropTypes.object.isRequired,
    isModalOpen: PropTypes.bool.isRequired,
    onCloseClick: PropTypes.func.isRequired,
    setFilter: PropTypes.func.isRequired,
};

module.exports = BrokerOrdersAndMovementsActivityFilter;
